e.A.general_info = {
	init: function(){
		$('#personal_info_submit').click(function(){
			e.A.general_info._send_data();
		});

		$('#share').click(function(){
			$('#share-icons').toggle();
		});

	},

	_send_data : function(){
		e.A.Messages.display_message( 'account_info_updated' );
		EdSpireAjax.Request( 'EdSpireAccountSettings', 'updateAccountInfo', $( '#personal-info' ).serializeArray(), function(){
		});
	}
};